import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  matchPath,
  useLinkClickHandler,
  useHref,
  useLocation,
  useParams,
  Link,
} from 'react-router-dom';
import { useStoreState } from 'easy-peasy';
import { selectorUser } from '@model/User';
import { USER_TYPES_MAP } from '@app/constants/session';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  jobActualStoreSelector,
  jobClientSelector,
} from '@model/Job/Job.selectors';
import {
  HERO_ROUTE_PATTERNS,
  ROUTE_TO_BACK_BUTTON_TARGET_MAP,
} from '@components/Hero/_constants/Hero.constants';
import { Action, ACTION_VARIANTS, ICON_NAMES } from '@reverse-hr/design-system';

export const Hero = ({
  className,
  title,
  isBackToJobAvailable,
  isBackToHomepageAvailable,
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { type: userType } = useStoreState(selectorUser);
  const { id: customerId } = useStoreState(jobClientSelector) || {};
  const path =
    HERO_ROUTE_PATTERNS.find(pattern => matchPath(pattern, pathname)) ?? '';

  const { jobId, entityId } = useParams();

  const wrapperClassNames = classNames('c-app-hero', className);

  const isUserManager = userType === USER_TYPES_MAP.MANAGER;
  const homepageLinkPath = isUserManager ? `/customers/${customerId}` : '/';

  const linkPathEntityId = jobId ?? entityId;
  const jobLinkPathStep = ROUTE_TO_BACK_BUTTON_TARGET_MAP[path] ?? '';
  const jobLinkPath = `/jobs/${linkPathEntityId}${jobLinkPathStep}`;
  const linkPath = isBackToJobAvailable ? jobLinkPath : homepageLinkPath;
  const isLinkVisible = isBackToJobAvailable || isBackToHomepageAvailable;
  const linkHref = useHref(linkPath);

  const labelName = isBackToJobAvailable
    ? 'candidate.hero.back_label'
    : 'hero.backToHomepage';

  return (
    <div className={wrapperClassNames}>
      {isLinkVisible && (
        <div className="c-app-masthead__back">
          <div className="c-back">
            <Link to={linkPath} className="c-back__anchor">
              <Action
                leftIcon={ICON_NAMES.CHEVRON_BIG_LEFT}
                variant={ACTION_VARIANTS.SIMPLE_TEXT}
              >
                {t(labelName, {
                  context: isUserManager ? 'headHunter' : null,
                })}
              </Action>
            </Link>
          </div>
        </div>
      )}

      {!!title && <h1 className="c-app-hero__title">{title}</h1>}
    </div>
  );
};

Hero.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  isBackToHomepageAvailable: PropTypes.bool,
};
